import { createStyles, Header, Menu, Group, Burger, Button, useMantineTheme, Drawer, Stack, Collapse, Input, ScrollArea, Image } from '@mantine/core';
import { ArrowsCross, ArrowsDiagonal, ArrowsDoubleNeSw, Language, Network, Search } from 'tabler-icons-react';
import { useState } from 'react';
import { getHotkeyHandler } from '@mantine/hooks';
import { GetTranslated } from '../types/translate-field';
import DefaultContainer from './container';
import { CategoryMap } from './category-navbar';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { CurrentLocale } from '../App';
import { PortalLink } from '../apis/response/GetPortalResponse';

const useStyles = createStyles((theme) => ({
    logo: {
        height: '100px',
        width: 'auto',
        objectFit: 'scale-down'
    },

    container: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        height: '100%',
        alignItems: 'center',
        [theme.fn.smallerThan('md')]: {
            padding: '0px 20px',
        },
    },

    links: {
        justifyContent: 'flex-end',
        [theme.fn.smallerThan('md')]: {
            display: 'none',
        },
    },

    burger: {
        [theme.fn.largerThan('md')]: {
            display: 'none',
        },
    },

    link: {
        height: 'auto',
        padding: '15px 12px',
        borderRadius: 0,
        textDecoration: 'none',
        color: theme.colors.hkc[0],
        fontSize: "theme.fontSizes.sm",
        fontFamily: ["Microsoft JhengHei"],
        fontWeight: 500,
        border: 0,

        '&:hover': {
            paddingBottom: 10,
            borderBottom: `5px solid ${theme.colors.hkc[1]}`
        },
    },

    linkLabel: {
        marginRight: 5,
    },

    portalBtn: {
        backgroundColor: theme.colors.hkc[0],
        '&:hover': {
            backgroundColor: theme.colors.offWhite[0],
            color: theme.colors.hkc[0],
            border: `1px solid ${theme.colors.hkc[0]}`
        }
    },
    langBtn: {
        backgroundColor: theme.colors.hkc[1],
        '&:hover': {
            backgroundColor: theme.colors.offWhite[0],
            color: theme.colors.hkc[1],
            border: `1px solid ${theme.colors.hkc[1]}`
        }
    },

    imgLink: {
        '&:hover': {
            cursor: 'pointer'
        },
        width:'350px',
        [theme.fn.smallerThan('md')]: {
            width:'calc(100% - 30px)',
        },
    },

    mobileBtn: {
        padding: '10px 20px',
        borderRadius: 0,
        backgroundColor: theme.colors.offWhite[0],
        color: theme.colors.hkc[0],
        fontWeight: 500
    },
    mobileCat: {
        color: theme.colors.hkc[0],
        fontWeight: 500,
        borderRadius: 0,
        padding: 10,
        height: '34px',
        width: '100%',
        display: 'flex',
        alignItems: 'start',
        marginLeft: 5,
        border: 0,
        borderLeft: `5px solid ${theme.colors.hkc[1]}`,
        paddingLeft: 5,
        position: 'relative'
    },
    mobileBg: {
        position:'absolute',
        top:0,
        bottom:0,
        left:0,
        right:0,
        padding:'10px 5px'
    },
    mobilePlus: {
        position:'absolute',
        right:'20px',
        top:'5px',
        fontSize:'25px',
        zIndex:1,
        width:'30px',
        height:'30px',
        textAlign:'center',
        
    },
    mobileSubMenu: {
        padding:'10px 0 10px 15px',
        color: theme.colors.hkc[0],
        fontWeight: 500,
        display:'none',
        
    },
    show: {
        display:'block'
    },
    mobileSubCat: {
        display:'block',
        color:'rgb(34,139,230)',
        padding:'10px 0px',
        fontSize:'14px',
        textAlign:'left',
        width:'calc(100% - 15px)',
        cursor:'pointer',
        '&:hover': {
            backgroundColor: '#E7F5FF',
            color: theme.colors.hkc[0],
        },
    }
}));

interface ILink {
    link: string; label: string; links?: ILink[]; icon?: React.ReactNode; locale?: boolean;
}

function ButtonMenu(text: string, icon: React.ReactNode, btnClass: string, links: ILink[]) {
    const theme = useMantineTheme()
    const { i18n } = useTranslation()
    const changeLanguage = (lang: string) => {
        i18n.changeLanguage(lang)
        localStorage.setItem('language', lang)
        window.location.reload()
    }
    return (
        <Menu transition={'pop-top-right'} trigger='hover' width={200}>
            <Menu.Target>
                <Button leftIcon={icon} style={{ paddingRight: 12 }} className={btnClass}>
                    {text}
                </Button>
            </Menu.Target>
            <Menu.Dropdown>
                {links.map((link) => {
                    return (
                        <Menu.Item
                            key={link.link}
                            icon={link.icon}
                            color={theme.colors.hkc[0]}
                            style={{ fontWeight: 500, textDecoration: 'unset' }}
                            onClick={() => changeLanguage(link.link)}
                        >
                            {link.label}
                        </Menu.Item>
                    )
                })}
            </Menu.Dropdown>
        </Menu>
    );
}

const HeaderMenu = (props: { logo: string, categories: CategoryMap, useful: PortalLink[] }) => {
    const [opened, toggleOpened] = useState(false);
    const [portalCollapse, togglePortalCollapse] = useState(false);
    const [deptCollapse, toggleDeptCollapse] = useState(false);
    const [langCollapse, toggleLangCollapse] = useState(false);
    const [temp, setTemp] = useState(false);
    const [useful, setUseful] = useState(false);
    const { classes } = useStyles();
    const theme = useMantineTheme();
    console.log(props.categories);
    const toggleDeptCollapse_program = (index:any) => {
        let icon = document.querySelectorAll("."+classes.mobilePlus)[index].innerHTML
        if(icon=="+") {  
            document.querySelectorAll("."+classes.mobilePlus)[index].innerHTML="-"
            document.querySelectorAll("."+classes.mobileSubMenu)[index].classList.add(classes.show)
        } else {     
            document.querySelectorAll("."+classes.mobilePlus)[index].innerHTML="+"
            document.querySelectorAll("."+classes.mobileSubMenu)[index].classList.remove(classes.show)
        }
    }

    const { t, i18n } = useTranslation('header');
    const changeLanguage = (lang: string) => {
        i18n.changeLanguage(lang)
        localStorage.setItem('language', lang)
        window.location.reload()
    }
    const sect = useTranslation('common', { keyPrefix: 'section' })
    const [search, inputSearch] = useState('')

    const headerLinks: ILink[] = [
        { link: '/', label: t('home') },
        { link: '/AboutUs', label: t('about-us') },
        { link: '/ContactUs', label: t('contact-us') },
    ];
    const tempPortal: ILink[] = [
        // { link: 'https://holiday.hkconnections.com.hk', label: 'HKC Online Leave System' },
        // { link: 'https://holiday.cnconnections.com/eLeave/', label: 'SZN Online Leave System' },
        // { link: 'https://holiday.hkconnections.com.hk', label: 'HK Online Leave System' },
        // { link: 'https://holiday.cnconnections.com/eLeave/', label: 'CN Online Leave System' },
        // { link: 'https://mail.hkconnections.com.hk/', label: 'HKC Outlook Web Access' },
        // { link: 'https://mail.hkconnections.com.hk/', label: 'HK Web Mail' },
        // { link: 'https://mail.cnconnections.com/', label: 'CN Web Mail' },
        // { link: 'http://www.hkconnections.com.hk:8090/', label: 'Login' },
    ]
    const langLinks: ILink[] = [
        { link: 'en', label: 'English', locale: true },
        { link: 'zh', label: '繁體中文', locale: true },
        { link: 'cn', label: '简体中文', locale: true },
    ];

    const getDeptSlug = (slug: string) => {
        const cat = slug.split('/')[0]
        return {
            cat: cat,
            slug: slug.replace(cat, '')
        }
    }

    const items = headerLinks.map((link) => {
        return (
            <Button
                component="a"
                href={link.link}
                key={link.label}
                className={classes.link}
                variant='subtle'
            >
                {link.label}
            </Button>
        );
    });

     const tempPortalBtn = () => {
        return (
            <Menu transition={'pop-top-right'} trigger='hover' width={200}>
                <Menu.Target>
                    <Button leftIcon={<ArrowsDoubleNeSw size={14} />} style={{ paddingRight: 12 }} className={classes.portalBtn} 
                    onClick={()=> window. location.href='http://www.hkconnections.com.hk:8090/'}>
                        {`Connect Login`}
                    </Button>
                </Menu.Target>
                {/* <Menu.Dropdown>
                    {tempPortal.map((link) => {
                        return (
                            <Menu.Item
                                key={link.link}
                                icon={link.icon}
                                color={theme.colors.hkc[0]}
                                style={{ fontWeight: 500, textDecoration: 'unset' }}
                                onClick={() => window.open(link.link, '_blank')}
                            >
                                <a href={link.link} target={'_blank'} style={{ textDecoration: 'unset', color: theme.colors.hkc[0] }}>
                                    {link.label}
                                </a>
                            </Menu.Item>
                        )
                    })}
                </Menu.Dropdown> */}
            </Menu>
        )
    }

    function searchByKey() {
        window.location.replace(`${window.location.origin}/Search/${search}`)
    }

    return (
        <Header height={100} mb={0} sx={{ position: 'sticky' ,}}>
            <DefaultContainer className={classes.container} style={{ flexDirection: 'row' }}>
                <Link to={'/'} >
                    <img className={classes.imgLink} src={props.logo} />
                </Link>
                <div>
                    <Group spacing={5} className={classes.links}>
                        {items}
                        {/* <Link to={'/User/login'}>
                            <Button className={classes.portalBtn}
                                leftIcon={<ArrowsExchange />}>{'Connect'}</Button>
                        </Link> */}
                        {tempPortalBtn()}
                        {ButtonMenu(t('language'), <Language size={14} />, classes.langBtn, langLinks)}
                        <Input placeholder={t('search')} icon={<Search size={14} />}
                            onChange={(x: any) => inputSearch(x.target.value)}
                            onKeyDown={
                                getHotkeyHandler([
                                    ['Enter', () => searchByKey()]
                                ])
                            }
                            rightSection={search != '' ?
                                <Link to={`/search/${search}`}>
                                    <Button className={classes.portalBtn}>{t('search')}</Button>
                                </Link>
                                : <></>} />
                    </Group>
                    <Burger
                        opened={opened}
                        onClick={() => toggleOpened((curr) => !curr)}
                        className={classes.burger}
                        size="sm"
                    />
                </div>
            </DefaultContainer>
            <Drawer
                opened={opened}
                onClose={() => toggleOpened(false)}
                withCloseButton={false}
                size="md"
                transitionDuration={250}
                transitionTimingFunction="ease"
            >
                <ScrollArea style={{ height: '100vh' }}>
                    <Stack spacing={'xs'}>
                        <Button radius={0} onClick={() => togglePortalCollapse(curr => !curr)} style={{ backgroundColor: theme.colors.hkc[0], padding: 10, height: 'unset', color: 'white', width: '100%' }}>{sect.t('category')}</Button>
                        <Collapse in={portalCollapse}>
                            <Stack>
                                {props.categories ? props.categories.categories.map(x => {
                                    return (
                                        <Button onClick={() => window.location.replace(x.slug)} variant='subtle' className={classes.mobileCat}>
                                            {GetTranslated(x.label, CurrentLocale)}
                                        </Button>
                                    )
                                })
                                    : <></>
                                }
                            </Stack>
                        </Collapse>

                        <Button radius={0} onClick={() => toggleDeptCollapse(curr => !curr)} style={{ backgroundColor: theme.colors.hkc[0], padding: 10, height: 'unset', color: 'white', width: '100%' }}>{sect.t('department')}</Button>
                        <Collapse in={deptCollapse}>
                            <Stack>
                                {props.categories ? props.categories.departments.map((x,index) => {
                                    return (
                                        <div>
                                            <Button variant='subtle' className={classes.mobileCat}>
                                                <div className={classes.mobileBg} onClick={() => window.location.replace(getDeptSlug(x.info.slug).slug)}>{GetTranslated(x.info.label, CurrentLocale)}</div>
                                                <div className={classes.mobilePlus} onClick={() => {toggleDeptCollapse_program(index)}}>+</div>
                                            </Button>
                                            <div className={classes.mobileSubMenu}>
                                                {x.subCat ? x.subCat.map((y) => {
                                                    return (
                                                        <div className={classes.mobileSubCat} onClick={() => window.location.replace(y.slug)}>
                                                            {GetTranslated(y.label, CurrentLocale)}
                                                        </div>
                                                    )
                                                }):<></>}
                                            </div>
                                        </div>
                                    )
                                })
                                    : <></>
                                }
                            </Stack>
                        </Collapse>

                        <Button radius={0} onClick={() => setUseful(curr => !curr)} style={{ backgroundColor: theme.colors.hkc[0] }}>{sect.t('useful-links')}</Button>
                        <Collapse in={useful}>
                            <Group>
                                {props.useful.map((link) => {
                                    return (
                                        // <button
                                        //     key={link.link}
                                        //     color={theme.colors.hkc[0]}
                                        //     style={{ fontWeight: 500, textDecoration: 'unset' }}
                                        // >
                                        <a href={link.link} target={'_blank'} style={{ width: '100%', textDecoration: 'unset', color: theme.colors.hkc[0], marginLeft: 5, borderLeft: `5px solid ${theme.colors.hkc[1]}`, paddingLeft: 5 }}>
                                            {link.name}
                                        </a>
                                        // </button>
                                    )
                                })}
                            </Group>
                        </Collapse>

                        {/* {headerLinks.map((link) => {
                            return <Link key={link.link} to={link.link} style={{ textDecoration: 'unset' }}>
                                <a className={classes.mobileBtn} href={link.link}>
                                    {link.label} {t("123")}
                                </a>
                            </Link>
                        })} */}
                        {headerLinks.map((link) => {
                            return <Link key={link.link} to={link.link} style={{ textDecoration: 'unset' }}>
                                <a className={classes.mobileBtn} onClick={() => window.location.replace(link.link)}>
                                    {link.label}
                                </a>
                            </Link>
                        })}

                        <Button radius={0} onClick={() => window.open('http://www.hkconnections.com.hk:8090/')} style={{ backgroundColor: theme.colors.hkc[0] }}>{'Connect Login'}</Button>
                        <Collapse in={temp}>
                            <Group>
                                {tempPortal.map((link) => {
                                    return (
                                        // <button
                                        //     key={link.link}
                                        //     color={theme.colors.hkc[0]}
                                        //     style={{ fontWeight: 500, textDecoration: 'unset' }}
                                        // >
                                        <a href={link.link} target={'_blank'} style={{ textDecoration: 'unset', color: theme.colors.hkc[0], marginLeft: 5, borderLeft: `5px solid ${theme.colors.hkc[1]}`, paddingLeft: 5 }}>
                                            {link.label}
                                        </a>
                                        // </button>
                                    )
                                })}
                            </Group>
                        </Collapse>

                        <Button radius={0} onClick={() => toggleLangCollapse(curr => !curr)} style={{ backgroundColor: theme.colors.hkc[1] }}>{t('language')}</Button>
                        <Collapse in={langCollapse}>
                            <Group>
                                {langLinks.map((link) => {
                                    return (
                                        <Button
                                            variant='subtle'
                                            key={link.link}
                                            color={theme.colors.hkc[0]}
                                            style={{ fontWeight: 500, textDecoration: 'unset', color: theme.colors.hkc[0] }}
                                            onClick={() => changeLanguage(link.link)}
                                        >
                                            {link.label}
                                        </Button>
                                    )
                                })}
                            </Group>
                        </Collapse>
                    </Stack>
                </ScrollArea>
            </Drawer>
        </Header>
    );
}

export default HeaderMenu